import SoftwareUtils from "./common-utils.js";
import { CommonSoftwareModel, CommonSoftwareView, CommonSoftwareController } from "./common-software-mvc.js";
import IllumioDomUtils from "../common/dom_utils.js";

/**********************************************************************
 * Software Download MVC with Version Selection
 *********************************************************************/

// Inherit CommonSoftwareModel
export class SoftwareDownloadModel extends CommonSoftwareModel {
    constructor(filename) {
        super(filename);
        
        this.version = null;
        this.releaseVersion = null;
    }
    
    // Object.defineProperty(SoftwareDownloadModel, 'constructor', {
    //     value: SoftwareDownloadModel,
    //     enumerable: false,
    //     writable: true,
    // });
    
    // SoftwareDownloadModel.prototype = Object.create(CommonSoftwareModel.prototype);
    
    /**
     * Public method.
     */
    setVersion(version) {
        if (version) {
            this.version = version;
        } else if (location.hash) {
            var hashParts = location.hash.substring(1).split('/');
            if (hashParts.length>=3) {
                this.version = hashParts[2];
            }
        }
        
        if (this.data && this.data.software_releases) {
            const softwareReleasesForEachHandler = function(record) {
                if (record.version===this.version) {
                    this.releaseVersion = record.release_version;
                }
            }
            this.data.software_releases.forEach(softwareReleasesForEachHandler.bind(this));
        }
    }
}

export class SoftwareDownloadView extends CommonSoftwareView {
    constructor(model) {
        super(model);
        
        // this.versionRadioButtonEvent = new IllumioEvent(this);
        
        this.elements = SoftwareUtils.createChildrenCache([ 'resources', 'error', 'versions', 'eula', 'download', 'resources-mobile' ]);
    }
    
    // Object.defineProperty(SoftwareDownloadView, 'constructor', {
    //     value: SoftwareDownloadView,
    //     enumerable: false,
    //     writable: true,
    // });
    
    // SoftwareDownloadView.prototype = Object.create(CommonSoftwareView.prototype);
    
    /**
     * Public method.
     */
    renderResult() {
        if (!this.model.version) {
            // Typically used for the initial page load with version information in the location hash.
            this.model.setVersion(null);
        }
        console.debug('SoftwareDownloadView: renderResult(): version: ' + this.model.version);
        
        this.renderVersionOptions();
        
        if (this.model.version) {
            // Track the version to be displayed.
            this.model.displayVersions = [ this.model.version ];
            
            this.renderResources();
            this.renderDownloads();
        }
    }
    
    renderVersionOptions() {
        console.debug('SoftwareDownloadView: renderVersionOptions()');
        console.debug('Current Version: ' + this.model.version);
        
        if (this.elements['versions'] && this.elements['versions'].childElementCount==0) {
            this.elements['versions'].appendChild(IllumioDomUtils.createSimpleTextBlock('h2', 'Select Version', null));
            
            let firstRadioElement = null;
            const softwareReleasesForEachHandler = function(release, index) {
                let displayText = release.release_version;
                
                // START SP-541: Show entire version when you have multiple maintenance releases with the same
                // major version
                let count = 0
                for (let i = 0; i < this.model.data.software_releases.length; i++) {
                    if (release.release_version == this.model.data.software_releases[i].release_version) {
                        count += 1
                    }
                }
                if (count > 1) {
                    displayText = release.version.split("+")[0]
                }
                // END SP-541

                // START SP-621: NEN should always be full form
                if (release.software_type == 'nen') {
                    displayText = release.version.split("+")[0]
                }
                // END SP-621
                if (release.release_type==='LTS') {
                    displayText += ' LTS';
                } else if (release.release_type==='LTS Candidate') {
                    displayText += ' LTS Candidate';
                }
                
                // if (release.notes && release.notes.trim().length>0) {
                //     displayText += ' (' + release.notes.trim() + ')';
                // }
                
                const classList = ['software-version-radio', 'radio'];
                const radioElement = IllumioDomUtils.createRadioButton('version', release.version, displayText, 
                        classList, release.version===this.model.version, this.versionRadioButtonOnClickHandler.bind(this));
                this.elements['versions'].appendChild(radioElement);
                
                if (index==0) {
                    firstRadioElement = radioElement;
                }
            }
            this.model.data.software_releases.forEach(softwareReleasesForEachHandler.bind(this));
            if (this.model.data.software_releases.length>0) {
                this.elements['versions'].classList.remove('hidden');
            }
            if (this.model.data.software_releases.length==1 && firstRadioElement) {
                firstRadioElement.click();
            }
        }
    }
    
    versionRadioButtonOnClickHandler(event) {
        this.elements['error'].classList.add('hidden');
        // this.versionRadioButtonEvent.notify(event);
        this.emit('versionRadioButton', {});
    }
}

export class SoftwareDownloadController extends CommonSoftwareController {
    constructor(model, view) {
        super(model, view);
        
        // this.view.versionRadioButtonEvent.attach(versionRadioButtonEventHandler.bind(this));
        this.view.on('versionRadioButton', this.versionRadioButtonEventHandler.bind(this));
    }
    
    versionRadioButtonEventHandler = function() {
        console.debug('version: ' + event.target.value);
        this.model.setVersion(event.target.value);
        
        const hashParts = location.hash.substring(1).split('/');
        if (hashParts.length==2) {
            hashParts.push(event.target.value);
        } else if (hashParts.length>=3) {
            hashParts[2] = event.target.value;
        }
        if (hashParts.length>=3) {
            location.hash = hashParts.join('/');
        }
    }
}